module.exports = __webpack_public_path__ + "static/489150096-wide.99066863.jpg";